import React, { useEffect, useRef, useContext, useState } from 'react';
import { UserContext } from 'context';
import { useDispatch } from 'react-redux';

import i18n from 'i18n-js';
import { buildUrl } from 'utils';
import Layout from 'components/Layout';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { Container, Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { withRouter, useParams } from 'react-router-dom';
import { CustomerGroupOnboarding } from 'components/VehiclesGroups';
import { VehiclesGroupsActions } from 'state/modules/vehiclesGroups';

const VehiclesGroupsOnboarding = ({ history, ...props }) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const onboardingRef = useRef();
  const { orgType } = useContext(UserContext);
  const [showSaveAndExitBtn, setShowSaveAndExitBtn] = useState(false);

  /**
   * Hancdle save and exit event
   */
  const handleOnSaveAndExit = () => {
    if (onboardingRef.current) {
      onboardingRef.current.handleOnSaveAndExit();
    }
  };

  useEffect(() => {
    if (id) {
      dispatch(VehiclesGroupsActions.fetchVehicleGroupById(id));
    }
  }, [id, dispatch]);

  return (
    <Layout title="Dashboard">
      <Container maxwidth="lg">
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              style={{ marginBottom: 48 }}
            >
              <Grid item>
                <Typography variant="h6" gutterBottom>
                  <Box fontWeight="fontWeightBold" fontSize={24} my={1}>
                    {i18n.t(
                      `vehicle_groups.${!id ? 'create_vehicle_groups' : 'edit_vehicle_groups'}`
                    )}
                  </Box>
                </Typography>
              </Grid>
              {showSaveAndExitBtn && (
                <Grid item>
                  <Button onClick={handleOnSaveAndExit} variant="contained" color="primary">
                    {i18n.t('wizard.save_and_exit')}
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <CustomerGroupOnboarding
              forwardRef={onboardingRef}
              onSave={setShowSaveAndExitBtn}
              mode={id ? 'edit' : 'create'}
            />
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default withRouter(VehiclesGroupsOnboarding);
